import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';

////////////// utils
import {treasureCompletionEvent} from 'src/Utils/huntFunctions';

/////////////// components
import {BodyText, ChallengeCard} from 'src/Modules/CommonView';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {apiCheckAnyChallenge} from 'src/Utils/apiCalls';
import CustomActivityIndicator from '../../Modules/CommonView/CustomActivityIndicator';

const checkmark = require('src/Images/Icons/checkmark.png');

const Treasure = () => {
  const userId = useSelector((state) => state.user?.userId);
  const groupInfo = useSelector((state) => state.groupInfo);
  const treasureChallengeData = [
    ...(useSelector((state) => state.game?.treasureChallengeData) || []),
  ];

  const handleSelectChallenge = (challenge) => {
    const isVideo =
      challenge.isVideo ||
      challenge.type === 'video' ||
      challenge.type === 'Video';

    navigationRef.navigate('PhotoVideoCamera', {
      onScore: async (data) => {
        const checkParams = {
          challenge_id: challenge.challenge_id,
          photo_url: data?.downloadURL,
          shareUUID: challenge.shareUUID,
          user_id: userId,
          group_id: groupInfo?.groupId,
          share_UUID: data?.shareUUID,
        };
        console.log({checkParams});
        return await apiCheckAnyChallenge(checkParams);
      },
      onFailScore: (data) => {
        // return Alert.alert('You failed the challenge!');
        const {photo_grade = {}, lr_app_challenge_completion_id = 0} = data;
        const {
          feedback_title = 'Close but no Cigar!!!!',
          feedback_body = 'We were not able to detect the required elements in the image!',
        } = photo_grade;

        navigationRef.navigate('ConfirmModal', {
          handleConfirm: async () => {
            navigationRef.goBack();
            handleSelectChallenge(challenge);
          },
          confirmText: 'Try Again',
          cancelText: 'Report Issue',
          handleCancel: () => {
            navigationRef.goBack();
            navigationRef.navigate('QuestionFeedback', {
              challenge,
              lr_app_challenge_completion_id,
              type: 'daily_challenge',
              challenged_by_user: 1,
            });
          },
          thirdOption: 'Cancel',
          handleThird: () => {
            navigationRef.goBack();
          },
          confirmColor: global?.color?.orange,
          cancelColor: global?.color?.blue,
          titleText: feedback_title,
          titleImage: require('src/Images/sadTrophy.png'),
          titleBodyText: feedback_body,
        });
      },
      onCapture: (data) => {
        const params = {
          selectedChallengeIndex: challenge.index,
          selectedChallengeId: challenge.challengeId,
          title: challenge.name,
          challenge: challenge.task,
          pointsEarned: 100,

          ...data,
        };
        treasureCompletionEvent(params, groupInfo, userId);
      },
      onReport: () => {
        navigationRef.navigate('QuestionFeedback', {
          challenge: {...challenge, theme: 'standard'},
          type: 'Treasure',
        });
      },
      shareUUID: challenge.shareUUID,
      text: challenge.task,
      photoUrl: challenge.photoUrl,
      isVideo,
      feedbackUnits: 'Points',
      feedbackPoints: challenge.points || 10,
    });
  };

  const {isBarHunt = false, classic_hunt} = groupInfo;

  if (isBarHunt || classic_hunt) {
    return <View />;
  }

  if (!treasureChallengeData) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: global?.color?.white,
        }}>
        <CustomActivityIndicator />
      </View>
    );
  }

  let completedChallenges =
    (!!treasureChallengeData?.length &&
      treasureChallengeData?.reduce((acc, chal) => {
        if (chal.photoUrl) {
          return acc + 1;
        }
        return acc;
      }, 0)) ||
    0;

  return (
    <View
      style={{
        backgroundColor: global?.color?.white,
        marginTop: 5,
      }}>
      {!!treasureChallengeData?.length && (
        <BodyText
          text={`Team Challenges:`}
          textStyle={{marginBottom: 5, fontWeight: '700'}}
        />
      )}
      {!!treasureChallengeData?.length &&
        treasureChallengeData
          .sort((a, b) => {
            if (!a?.photoUrl && b?.photoUrl) {
              return 1;
            }
            if (!b?.photoUrl && a?.photoUrl) {
              return -1;
            }
            return 0;
          })
          ?.slice?.(0, completedChallenges + 4)
          ?.reverse?.()
          ?.map?.((challenge, index) => {
            return (
              <ChallengeCard
                testID={`challenge-${index}`}
                //eslint-disable-next-line
                key={`Challenge_Card_${challenge.challenge_id}_${challenge.name}_${challenge.index}`}
                title={challenge.name}
                description={challenge.task}
                icon={challenge.photoUrl ? checkmark : false}
                iconText={'100 pts'}
                completed={challenge.photoUrl}
                handlePress={() => {
                  handleSelectChallenge(challenge);
                }}
              />
            );
          })}
    </View>
  );
};

export default Treasure;
